


export class CostReviewSecurityEnUsIntercomSystem {
  isIntercomSystemChecked!: boolean;
  integrationWithOtherSystems!: number;
  isNewVendorChecked!: boolean;
  newVendor!: string;
  isReplacementVendorChecked!: boolean;
  replacementVendor!: string;
  isExpansionVendorChecked!: boolean;
  expansionVendor!: string;
  risk!: string;
  numberOfMasters!: number;
  numberOfSubstations!: number;
  employeesToTrain!: number;
  lowContractor!: string;
  numberOfBidders!: number;
}
